import React from 'react'
import Report from '../Components/Report/Report'

const ReportPage = () => {
  return (
    <Report />
  )
}

export default ReportPage